export default function orderPartForm() {
  return {
    isSplittable: false,
    deliveredAsOne: true,

    init() {
      const isSplittableCheckbox = document.querySelector("#id_is_splittable");
      const deliveredAsOneCheckbox = document.querySelector(
        "#id_delivered_as_one",
      );

      if (isSplittableCheckbox) {
        this.isSplittable = isSplittableCheckbox.checked;
      }
      if (deliveredAsOneCheckbox) {
        this.deliveredAsOne = deliveredAsOneCheckbox.checked;
      }

      this.$watch("isSplittable", (val) => {
        this.deliveredAsOne = !val;
      });
    },
  };
}
